function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import __ from 'ramda/src/__';
import pathOr from 'ramda/src/pathOr';
import { stateGo } from 'redux-ui-router';
import { RouteParams, RouteCurrentStateSelector } from 'invision-core/src/components/router/router.selectors';
import { getFilterService } from 'invision-core/src/components/injectables/injector.helper';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { fetchCodeTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
import { MetadataCodeLoadedSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { NON_BULK_SERVICE_STATUSES } from 'invision-core/src/constants/status.constants';
import CustomerLocaleKeys from '../../../../locales/keys';
import { CurrentCustomerIdSelector } from '../../../../reducers/selectors/customer.selectors';
import { retrieveServiceDetails, setSelectedServiceIdentifier, suspendOrResumeServices } from '../../../../reducers/actions/services.actions';
import { ResumeServiceReasonCodesSelector, SuspendServiceReasonCodesSelector } from '../../../../reducers/selectors/services.selectors';
import { SelectedServiceAssociatedServiceIdSelector, SelectedServiceDetailsSelector, SelectedServiceFormattedServiceIdentifierValueSelector } from '../../../../reducers/selectors/selected.service.details.selectors';
import { getSuspensionTypeByCode } from '../../../../reducers/selectors/services.list.selectors.helper';
import { SERVICES_AND_SHARED_ENTITLEMENTS } from '../services.and.usage.config';
import { RESUME_SERVICES_REDIRECT, SUSPEND_SERVICES_REDIRECT, SERVICE_ADD_ON_PRODUCTS_ORDERING_PAGE_ROUTE } from '../../../../reactRoutes';
var ServiceDetailsPageController = /*#__PURE__*/function () {
  function ServiceDetailsPageController($ngRedux, $timeout, uiNotificationService) {
    _classCallCheck(this, ServiceDetailsPageController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      backState: {
        name: SERVICES_AND_SHARED_ENTITLEMENTS
      },
      CustomerLocaleKeys: CustomerLocaleKeys,
      NON_BULK_SERVICE_STATUSES: NON_BULK_SERVICE_STATUSES,
      onCloseUpdateFriendlyNameModal: this.onCloseUpdateFriendlyNameModal.bind(this),
      onMoreMenuOptionsSelected: this.onMoreMenuOptionsSelected.bind(this),
      onSubmitUpdateFriendlyName: this.onSubmitUpdateFriendlyName.bind(this),
      onCloseUpdateServiceLifeCycleStatusModal: this.onCloseUpdateServiceLifeCycleStatusModal.bind(this),
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(ServiceDetailsPageController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var codeTables = [CODES.ReasonCodes, CODES.RegularExpression, CODES.ServiceAttribute, CODES.ServiceLifeCycleStatus];
      var controllerActions = {
        fetchCodeTypes: fetchCodeTypes,
        retrieveServiceDetails: retrieveServiceDetails,
        setSelectedServiceIdentifier: setSelectedServiceIdentifier,
        stateGo: stateGo,
        suspendOrResumeServices: suspendOrResumeServices
      };
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          codeTypeLoaded: MetadataCodeLoadedSelector(__, store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          formattedServiceValue: SelectedServiceFormattedServiceIdentifierValueSelector(store),
          resumeServiceReasonCodes: ResumeServiceReasonCodesSelector(store),
          routeParams: RouteParams(store),
          routeState: RouteCurrentStateSelector(store),
          serviceDetails: SelectedServiceDetailsSelector(store),
          serviceId: SelectedServiceAssociatedServiceIdSelector(store),
          suspendServiceReasonCodes: SuspendServiceReasonCodesSelector(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      codeTables.forEach(function (codeType) {
        if (!_this.state.codeTypeLoaded(codeType)) {
          _this.actions.fetchCodeTypes(codeType).catch(function (error) {
            _this.uiNotificationService.transientError(error.translatedMessage);
          });
        }
      });
      this.updateFriendlyNameModalConfig = {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this.updateFriendlyNameModalConfigApi = api;
        }
      };
      this.updateServiceLifeCycleStatusConfig = {
        onRegisterApi: function onRegisterApi(_ref2) {
          var api = _ref2.api;
          _this.updateServiceLifeCycleStatusConfigApi = api;
        }
      };
      this.suspendResumeModalConfig = {
        onRegisterApi: function onRegisterApi(_ref3) {
          var api = _ref3.api;
          _this.suspendResumeModalConfigApi = api;
        }
      };
      this.optionalParams = {
        serviceIdentifier: this.state.routeParams.serviceIdentifier
      };
      this.actions.setSelectedServiceIdentifier(this.state.routeParams.serviceIdentifier);
    }
  }, {
    key: "onMoreMenuOptionsSelected",
    value: function onMoreMenuOptionsSelected(_ref4) {
      var _this2 = this;
      var itemProps = _ref4.item;
      switch (itemProps.id) {
        case CustomerLocaleKeys.MANAGE_ADD_ONS:
          if (!itemProps.isLocked) {
            this.actions.stateGo(SERVICE_ADD_ON_PRODUCTS_ORDERING_PAGE_ROUTE, {
              customerId: this.state.currentCustomerId,
              serviceIdentifierValue: this.state.serviceDetails.ServiceIdentifier.Value,
              serviceId: this.state.serviceId,
              serviceAttributeId: this.state.serviceDetails.ServiceIdentifier.ServiceAttributeId
            });
          }
          break;
        case CustomerLocaleKeys.CUSTOMER_DASHBOARD.FRIENDLY_NAME.MODAL_TITLE:
          this.selectedService = {
            Value: this.state.serviceDetails.ServiceIdentifier.Value,
            FriendlyName: this.state.serviceDetails.ServiceIdentifier.FriendlyName
          };
          this.showUpdateFriendlyNameModal = true;
          this.$timeout(function () {
            _this2.updateFriendlyNameModalConfigApi.open();
          });
          break;
        case CustomerLocaleKeys.SUSPEND_SERVICE:
        case CustomerLocaleKeys.RESUME_SERVICE:
          this.openSuspendResumeServiceModal();
          break;
        case CustomerLocaleKeys.UPDATE_SERVICE_LIFECYCLE_STATUS:
          this.showUpdateServiceLifeCycleStatusModal = true;
          this.$timeout(function () {
            _this2.updateServiceLifeCycleStatusConfigApi.open();
          });
          break;
        default:
          break;
      }
    }
  }, {
    key: "onCloseUpdateFriendlyNameModal",
    value: function onCloseUpdateFriendlyNameModal() {
      this.showUpdateFriendlyNameModal = false;
      this.updateFriendlyNameModalConfigApi.close();
    }
  }, {
    key: "onSubmitUpdateFriendlyName",
    value: function onSubmitUpdateFriendlyName() {
      this.fetchServiceDetails();
      this.onCloseUpdateFriendlyNameModal();
    }
  }, {
    key: "openSuspendResumeServiceModal",
    value: function openSuspendResumeServiceModal() {
      if (this.state.serviceDetails.Status === NON_BULK_SERVICE_STATUSES.ACTIVE) {
        this.actions.stateGo(SUSPEND_SERVICES_REDIRECT, {
          customerId: this.state.currentCustomerId,
          serviceIdentifier: this.state.serviceDetails.ServiceIdentifier.Value
        });
      } else {
        this.actions.stateGo(RESUME_SERVICES_REDIRECT, {
          customerId: this.state.currentCustomerId,
          serviceIdentifier: this.state.serviceDetails.ServiceIdentifier.Value
        });
      }
    }
  }, {
    key: "onCloseUpdateServiceLifeCycleStatusModal",
    value: function onCloseUpdateServiceLifeCycleStatusModal() {
      this.showUpdateServiceLifeCycleStatusModal = false;
      this.updateServiceLifeCycleStatusConfigApi.close();
    }
  }, {
    key: "onSubmitUpdateServiceLifeCycleStatus",
    value: function onSubmitUpdateServiceLifeCycleStatus() {
      this.fetchServiceDetails();
      this.onCloseUpdateServiceLifeCycleStatusModal();
    }
  }, {
    key: "fetchServiceDetails",
    value: function fetchServiceDetails() {
      var _this3 = this;
      if (pathOr(null, ['serviceDetails', 'ServiceIdentifier', 'Value'], this.state)) {
        var serviceIdentifiers = [{
          Value: this.state.serviceDetails.ServiceIdentifier.Value
        }];
        this.actions.retrieveServiceDetails(this.state.currentCustomerId, serviceIdentifiers).catch(function (error) {
          _this3.uiNotificationService.transientError(error.translatedMessage);
        });
      }
    }
  }, {
    key: "suspensionDate",
    get: function get() {
      return getFilterService()('localShortDate')(this.state.serviceDetails.SuspendedDate);
    }
  }, {
    key: "suspensionTypeByCode",
    get: function get() {
      return getSuspensionTypeByCode(this.state.serviceDetails.SuspendTypeCode);
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}();
export default {
  template: require('./service.details.html'),
  controller: ServiceDetailsPageController
};